<template>
  <div class="container">
    <div class="topInfo flex flexMiddle">
      <div class="avatarBox">
        <img :src="avatar" v-if="avatar">
        <img src="@/assets/images/avatar.png" v-else>
      </div>
    </div>
    <div class="cellBox bg-fff">
      <div class="cellItem flexCenter flexBetween line-b-E5E5E5">
        <label for="username" class="requireSign">姓名：</label>
        <input type="text" id="username" v-model.trim="contentInfo.username" placeholder="请输入姓名" class=" textright flex1">
      </div>
      <div class="cellItem flexCenter flexBetween line-b-E5E5E5">
        <label for="certId" class="requireSign">身份证号码：</label>
        <input type="text" id="certId" v-model.trim="contentInfo.certId" placeholder="请输入证件号码" class=" textright flex1">
      </div>
      <div class="cellItem flexCenter flexBetween line-b-E5E5E5" @click="goChangePhone">
        <span class="">手机号：</span>
        <span class=" textright flex1">{{contentInfo.tel}}</span>
        <van-icon name="arrow" size="20" color="#969799" />
      </div>
      <div class="cellItem flexCenter flexBetween line-b-E5E5E5">
        <label for="email">邮箱地址：</label>
        <input type="text" id="email" v-model.trim="contentInfo.email" placeholder="请输入邮箱地址" class=" textright flex1">
      </div>
    </div>
    <div class="footerBtn">
      <van-button :disabled="fetching" round block type="info" native-type="submit" @click="onSubmit">提交</van-button>
    </div>
    <div class="loadingBox" v-if="isShowLoading">
      <van-loading size="30px" type="spinner" color="#1989fa" vertical>加载中...</van-loading>
    </div>
  </div>
</template>
<script>
import { Button, Toast, Icon, Dialog, Loading } from "vant";
import { isCardNo, checkIDCard, validatePhone, validateEmail } from '@/utils/validate'
export default {
  name: 'USerInfo',
  components: {
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [Loading.name]: Loading
  },
  data() {
    return {
      contentInfo: {
        username: '',
        certId: '',
        tel: '',
        noteCode: '',
        imgCode: '',
        email: ''
      },
      avatar:'',
      isSubmit: true, //是否禁止触发‘提交’
      isShowLoading: true,
      fetching: false
    }
  },
  created() {
    this.GLOBAL.iosInputHandle();
    this.getUserInfo();
  },
  watch: {
    contentInfo: {
      handler(val, oldval) {
        if (this.contentInfo.tel && this.contentInfo.tel.length > 11) {
          this.contentInfo.tel = this.contentInfo.tel.substr(0, 11)
        };
        if (this.contentInfo.noteCode && this.contentInfo.noteCode.length > 4) {
          this.contentInfo.noteCode = this.contentInfo.noteCode.substr(0, 4)
        };
        if (this.contentInfo.imgCode && this.contentInfo.imgCode.length > 4) {
          this.contentInfo.imgCode = this.contentInfo.imgCode.substr(0, 4)
        };
      },
      deep: true
    }
  },
  methods: {
    /*获取用户信息*/
    getUserInfo() {
      setTimeout(function() {
        this.isShowLoading = false;
      }, 2000);
      $.ajax({
        url: this.GLOBAL.url + '/openIdInfo/getByInfo',
        type: 'get',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {

        },
        success: (res) => {
          if (res.code == 200) {
            if (res.data) {
              this.contentInfo.username = res.data.name;
              this.contentInfo.certId = res.data.idcard;
              this.contentInfo.tel = res.data.mobile;
              this.contentInfo.email = res.data.mail;
              this.avatar = res.data.reserved1;
            };
          } else {
            Toast(res.msg)
          };
          this.isShowLoading = false;
        },
        error: (e) => {
          this.isShowLoading = false;
          console.log(e);
        }
      })
    },
    goChangePhone() {
      this.$router.push({ name: 'ChangePhone', params: { phone: this.contentInfo.tel ,avatar:this.avatar} })
    },
    onSubmit() {
      let self = this;
      if (!self.contentInfo.username) {
        Toast('请输入姓名！');
        return false;
      } else if (!self.contentInfo.certId) {
        Toast('请输入身份证号！');
        return false
      } else if (!isCardNo(self.contentInfo.certId)) {
        Toast('身份证号格式错误！');
        return false;
      } else if (!checkIDCard(self.contentInfo.certId)) {
        Toast('身份证号格式错误！');
        return false;
      } else if (!self.contentInfo.tel) {
        Toast('请输入手机号！');
        return false
      } else if (!validatePhone(self.contentInfo.tel)) {
        Toast('手机号格式错误！');
        return false;
      } else if (self.contentInfo.email) {
        if (!validateEmail(self.contentInfo.email)) {
          Toast('邮箱格式错误！');
          return false;
        }
      };
      Dialog.confirm({
        title: '提示',
        message: '确定保存当前数据？',
      }).then(() => {
        if (self.fetching == true) {
          return false
        };
        self.fetching = true;
        $.ajax({
          url: this.GLOBAL.url + '/openIdInfo/saveOrUpdate',
          type: 'post',
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          data: {
            name: self.contentInfo.username,
            idcard: self.contentInfo.certId,
            mobile: self.contentInfo.tel,
            code: self.contentInfo.noteCode,
            mail: self.contentInfo.email
          },
          success: (res) => {
            if (res.code == 200) {
              Toast('保存成功');
              setTimeout(() => {
                self.$router.go(-1);
              }, 1500);
            } else {
              Toast(res.msg);
            };
            self.fetching = false;
          },
          error: (e) => {
            self.fetching = false;
            console.log(e);
          }
        })
      }).catch(() => {
        // on cancel
      });
    }
  },
  computed: {}
}
</script>
<style scoped>
.container {
  width: 100%;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

.topInfo {
  padding: 10px 0;
}

.avatarBox {
  display: table-cell;
  width: 2.133333rem;
  height: 2.133333rem;
  vertical-align: middle;
  border-radius: 1.066667rem;
  overflow: hidden;
}

.avatarBox img {
  display: inline-block;
  width: 100%;
  height: 100%;
}

.cellBox {
  padding-left: 0.4rem;
}

.cellItem {
  padding: 0.4rem 0.4rem 0.4rem 0;
  border-bottom: 0.026667rem solid #f0f0f0; /* Lighter bottom border */
}
.cellItem:last-child {
  border-bottom: none; /* Remove border for the last item */
}


.requireSign:before {
  content: "*";
  display: inline-block;
  margin-right: 0.133333rem;
  color: #ff4d4f; /* Modern red */
}

.footerBtn {
  margin-top: 1.333333rem;
}

.loadingBox {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
}
</style>